export const ERROR_CODES = {
  1: 'error.missing-username',
  2: 'error.empty-eurotax',
  3: 'error.invalid-vehicleRegistrationDateISO8601',
  4: 'error.vehicleRegistrationDateISO8601-cant-be-in-the-future',
  5: 'error.invalid-vehicleKM',
  6: 'error.invalid-vendorType',
  7: 'error.invalid-referenceDateISO8601',
  8: 'error.referenceDateISO8601-cant-be-in-the-future',
  9: 'error.data-are-not-enough-for-price-prediction',
  10: 'error.vehicle-category',
  11: 'error.user-not-enabled',
} as const;
